import { http, HttpResponse } from 'msw';

import { DocumentResponse } from 'modules/common/interfaces/documents';

const emptyDocumentResponse: DocumentResponse = {
    total_records: 0,
    page_size: 100,
    total_pages: 0,
    current_page: 1,
    results: [],
};

export default {
    documentsSearch: http.post('*/documents/search', () => HttpResponse.json(emptyDocumentResponse)),
};
